import { render, staticRenderFns } from "./opnDetail.vue?vue&type=template&id=03ca8f06&scoped=true&"
import script from "./opnDetail.vue?vue&type=script&lang=js&"
export * from "./opnDetail.vue?vue&type=script&lang=js&"
import style0 from "./opnDetail.vue?vue&type=style&index=0&id=03ca8f06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ca8f06",
  null
  
)

export default component.exports